"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importStar(require("../Button"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var FilterConfirm = /** @class */ (function (_super) {
    __extends(FilterConfirm, _super);
    function FilterConfirm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterConfirm.prototype.render = function () {
        var _a = this.props, children = _a.children, onResetClick = _a.onResetClick, onConfirmClick = _a.onConfirmClick;
        return (react_1.default.createElement("div", { className: "filter_confirm" },
            react_1.default.createElement("div", { className: "row filter_confirm__element" },
                react_1.default.createElement("div", { className: "col-12" }, children)),
            react_1.default.createElement("div", { className: "row filter_confirm__buttons" },
                react_1.default.createElement("div", { className: "col-6" },
                    react_1.default.createElement("a", { onClick: onResetClick }, LocaleProvider_1.default.locs.datatable.filters.resetFilter)),
                react_1.default.createElement("div", { className: "col-6 align_right" },
                    react_1.default.createElement(Button_1.default, { onClick: onConfirmClick, variant: Button_1.ButtonVariant.Active }, LocaleProvider_1.default.locs.datatable.filters.confirm)))));
    };
    return FilterConfirm;
}(react_1.default.Component));
exports.default = FilterConfirm;
//# sourceMappingURL=index.js.map